import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useCalculatedConsumablesDemandHook from './calculated-consumables-demand.hook';
import * as styled from './calculated-consumables-demand.styles';
import themes from './themes';

import { Icon } from '@plasma/ui.general.icon';
import EditableTable from '../../components/edit-table';
import TopBar from '../../components/top-bar/top-bar';
import Button from '@plasma/ui.general.button';
import Modal from '@plasma/ui.layout.modal';

export interface CalculatedConsumablesDemandProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = CalculatedConsumablesDemandProps & ThemeOverride;

function CalculatedConsumablesDemand(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t,
          columnNames,
          dataForColumns,
          handleRowSelection,
          handleSaveAndDeleteFromTable,
          handleAddToCart,
          handleAdjustProdMix
  } = useCalculatedConsumablesDemandHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.CalculatedConsumablesDemand className={`calculated-consumables-demand ${className ?? ''}`.trim()} style={{maxHeight: '75vh'}}>
        <TopBar
          topHeading={t("calc-demand")}
          headingBGColor='#5B9AE155'
        />

        <div style={{display: 'flex', justifyContent: 'flex-end', margin: '0 2vh 1vh 0'}}>
          <Button
            title={t("adjust-product-mix")}
            onClick={handleAdjustProdMix}
            prefixIcon={{name:'back'}}
          />
        </div>

        <div style={{height: '76vh'}}>
        <EditableTable
          tableData={dataForColumns}
          tableColumns={columnNames}
          Table_Header=""
          hiddenColumns={[]}
          showActions_ext={false}
          allowSelection={false}
          saveReturnType={'row'}
          stillHiddenColumns={[]}
          handleSelection={handleRowSelection}
          onlyAddableFields={[]}
          allowInsertInitialBlankRow={false}
          clearTheSelection
          handleSave={handleSaveAndDeleteFromTable}
          loadingSpinnerVisible= {false}
        />
        </div>

        <div style={{display: 'flex', justifyContent: 'flex-end', margin: '3vh 2vh 0 0'}}>
          <Button
            style={{}}
            title={t("add-all")}
            onClick={handleAddToCart}
          />

          <Button
            style={{marginLeft: '2vw'}}
            title={t("generate-pdf")}
          />
        </div>

      </styled.CalculatedConsumablesDemand>
    </ThemeProvider>
  );
}

export default memo(CalculatedConsumablesDemand) as unknown as typeof CalculatedConsumablesDemand;
